module.exports = "/_next/static/images/CentralizeAndSimplify@2x-331439c332c6f44e3e938aeaaef9f99c.webp";